var serializeForm = function (form) {
	var obj = {};
	var formData = new FormData(form);
	for (var key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return obj;
};
const getForm = document.querySelector(".customProductForm");

getForm.addEventListener("submit", function(event){
  console.log('Form Submitted');
  event.preventDefault();
  var addToCartButton = event.target.querySelector('.customBtn__AddToCart');
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  var formElement = event.target;
  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(serializeForm(formElement)),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttribute('disabled');
      // We simply trigger an event so the mini-cart can re-render
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        addToCartButton.removeAttribute('disabled');
        addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });

  event.preventDefault();
});